import {createContext, useContext} from "react";
import type Position from "@/util/Position.ts";

export type TransformSnapshot = {
    id: string;
    position: Position;
    rotation?: number;
    levelId?: string;
}

export type TransformHistoryEntry =
    | {
        type: "combatants";
        before: TransformSnapshot[];
        after: TransformSnapshot[];
    }
    | {
        type: "areaEffect";
        before: TransformSnapshot;
        after: TransformSnapshot;
    };

export type TransformHistoryTarget =
    | {type: "combatants"; ids: string[]}
    | {type: "areaEffect"; id: string};

export type TableTopHistoryReturn = {
    canUndo: boolean;
    canRedo: boolean;
    beginInteraction: (target?: TransformHistoryTarget) => void;
    endInteraction: (after?: TransformSnapshot | TransformSnapshot[]) => void;
    undo: () => void;
    redo: () => void;
    clearHistory: () => void;
}

export const TableTopHistoryContext = createContext<TableTopHistoryReturn | null>(null);

export function useTableTopHistory(): TableTopHistoryReturn {
    const context = useContext(TableTopHistoryContext);
    if (!context) {
        throw new Error("useTableTopHistory must be used within a TableTopHistoryProvider");
    }
    return context;
}
